import script from "./ContactItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactItem.vue?vue&type=script&setup=true&lang=ts"

import "./ContactItem.vue?vue&type=style&index=0&id=063c669c&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\shiyu\\local_document\\projects\\vue\\hsmkai.github.io\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-063c669c"]])

export default __exports__
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QItem,QItemSection,QItemLabel});
